interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-file-search-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-background-300/70 bg-background-100/40 px-6 py-16 md:py-20 flex flex-col items-center text-center">
      <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500 mb-5">
        <i className={`${icon} text-2xl md:text-3xl`}></i>
      </div>
      <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-100">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 h-10 px-5 rounded-md bg-primary-500 text-foreground-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}